import type { AxiosError } from 'axios';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';

import { getUser } from '@hotjar/user';

export const USER_ID_QUERY_KEY = 'currentUser';

type ApiFunction = typeof getUser;
type ApiResponseType = Awaited<ReturnType<ApiFunction>>;

export function useUserInfos(
  userId: Parameters<ApiFunction>[0] | null,
): UseQueryResult<ApiResponseType, AxiosError> {
  return useQuery<ApiResponseType, AxiosError>([USER_ID_QUERY_KEY, userId], () => getUser(userId), {
    enabled: userId !== null,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
